export const translateStatus = (description: string | null): string => {
  if (!description) {
    return 'Unknown status';
  }

  const translations: { [key: string]: string } = {
    '상품이 고객님께 안전하게 배송되었습니다.': 'The product has been safely delivered to the customer.',
    '상품이 통관 절차를 성공적으로 완료했습니다. 현지 배송사에 인계됩니다.':
      'The product has successfully completed customs clearance and is being handed over to the local delivery service.',
    '상품이 목적 국가에 도착했습니다. 통관 절차 진행 후 배송됩니다.':
      'The product has arrived in the destination country. It will be delivered after customs clearance.',
    '상품이 한국을 출발하여 해외로 향하고 있습니다.': 'The product has departed from Korea and is heading overseas.',
    '송장이 발행되었습니다.': 'The invoice has been issued.',
  };

  return translations[description] || description;
};
